<template>
  <footer class="footer">
    <div class="container-db">
      <div class="top-footer">
        <div class="contact-us">
          <a href="/" class="logo" aria-label="to devbrother main page">
            <img v-lazyload height="40" width="70" data-url="/img/images-db/Logo.svg" alt="logo" />
          </a>
          <!--
          <div class="mobile-link">
            <img v-lazyload data-url="/img/images-db/phone_footer.svg" alt="phone">
            <a href="tel:+19292434659" target="_blank">USA: +1(929) 243-4659</a>
          </div>
          -->
          <textarea id="tmpTextField" name="hidden" aria-hidden="true" tabindex="-1" readonly></textarea>

          <div class="mobile-link">
            <img v-lazyload class="phone-icon" height="16" width="16" data-url="/img/images-db/phone_footer.svg"
              alt="phone">
            <span>USA:&nbsp;</span>
            <a id="phoneFooter4" href="tel:+19296298710" target="_blank" aria-label="devbrother company USA phone">+(1) 929-629-8710</a>
            <button v-on:click="copyToClipboard('phoneFooter4', 'tel:'); showCopyPopup4()" class="copy-btn"
              :class="{ 'block-button': showCopyModal4 }" title="Copy contact">
              <div class="popup-copy-contact" :class="{ 'hide-popup': !showCopyModal4 }">
                Contact copied
              </div>
              <img v-lazyload class="copy-icon" height="20" width="20" data-url="/img/images-db/copy-footer-icon.svg"
                alt="copy-icon">
            </button>
          </div>


          <div class="mobile-link">
            <img v-lazyload class="phone-icon" height="16" width="16" data-url="/img/images-db/phone_footer.svg"
              alt="phone">
            <span>PL:&nbsp;</span>
            <a id="phoneFooter1" href="tel:+48572364123" target="_blank" aria-label="devbrother company Poland phone">+(48) 572-364-123</a>
            <button v-on:click="copyToClipboard('phoneFooter1', 'tel:'); showCopyPopup1()" class="copy-btn"
              :class="{ 'block-button': showCopyModal1 }" title="Copy contact">
              <div class="popup-copy-contact" :class="{ 'hide-popup': !showCopyModal1 }">
                Contact copied
              </div>
              <img v-lazyload class="copy-icon" height="20" width="20" data-url="/img/images-db/copy-footer-icon.svg"
                alt="copy-icon">
            </button>
          </div>

          <div class="mobile-link">
            <img v-lazyload class="phone-icon" height="16" width="16" data-url="/img/images-db/phone_footer.svg"
              alt="phone">
            <span>UA:&nbsp;</span>
            <a id="phoneFooter2" href="tel:+380938922544" target="_blank" aria-label="devbrother company Ukraine phone">+(380) 938-922-544</a>
            <button v-on:click="copyToClipboard('phoneFooter2', 'tel:'); showCopyPopup2()" class="copy-btn"
              :class="{ 'block-button': showCopyModal2 }" title="Copy contact">
              <div class="popup-copy-contact" :class="{ 'hide-popup': !showCopyModal2 }">
                Contact copied
              </div>
              <img v-lazyload class="copy-icon" height="20" width="20" data-url="/img/images-db/copy-footer-icon.svg"
                alt="copy-icon">
            </button>
          </div>



          <div class="email-link">
            <img v-lazyload class="email-icon" height="24" width="24" data-url="/img/images-db/icons/mail.png"
              alt="email">
            <a id="emailFooter" href="mailto:contact@devbrother.com" target="_blank" aria-label="devbrother company email">
              contact@devbrother.com</a>
            <button v-on:click="copyToClipboard('emailFooter', 'mailto:'); showCopyPopup3()" class="copy-btn"
              :class="{ 'block-button': showCopyModal3 }" title="Copy contact">
              <div class="popup-copy-contact" :class="{ 'hide-popup': !showCopyModal3 }">
                Contact copied
              </div>
              <img v-lazyload class="copy-icon" height="20" width="20" data-url="/img/images-db/copy-footer-icon.svg"
                alt="copy-icon">
            </button>
          </div>
        </div>
        <nav class="footer-menu">
          <ul class="footer-menu-list">
            <li class="footer-menu-item no-change-color footer-item-service">
              <p class="footer-menu-item__title">Services</p>
              <ul class="footer-submenu">
                <li>
                  <router-link to="/services/web3-development">Web3 Development</router-link>
                </li>
                <li>
                  <router-link to="/services/web-development">Web Development</router-link>
                </li>
                <li>
                  <router-link to="/services/mobile-development">Mobile Development</router-link>
                </li>
                <li>
                  <router-link to="/services/qa-automation">QA Automation & Testing</router-link>
                </li>
                <li>
                  <router-link to="/services/devops">DevOps</router-link>
                </li>
                <li>
                  <router-link to="/services/ui-ux-user-testing">UI/UX & User Testing</router-link>
                </li>
                <li>
                  <router-link to="/blog/staff-augmentation">Staff Augmentation</router-link>
                </li>
                <li>
                  <router-link to="/services/staff-augmentation-service">IT Staff Augmentation</router-link>
                </li>
                <li>
                  <router-link to="/services/dedicated-development-team">Dedicated Development Team</router-link>
                </li>
                <li class="footer-menu-item no-change-color footer-item-service industry">
                  <p class="footer-menu-item__title">Industries</p>
                  <ul class="footer-submenu">
                    <li>
                      <router-link to="/industries/healthcare-software-development">Healthcare Software Development</router-link>
                    </li>
                    <li>
                      <router-link to="/industries/cryptocurrency-development">Cryptocurrency Development</router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li class="footer-menu-item no-change-color">
              <p class="footer-menu-item__title">Portfolio</p>
              <ul class="footer-submenu">
                <li><router-link to="/cases/banking-app">Banking Application</router-link></li>
                <li><router-link to="/cases/markets-exchanges">Markets and Exchanges</router-link></li>
                <li><router-link to="/cases/flexiswap-nft-swap-platform">NFT Swap Platform</router-link></li>
                <li><router-link to="/cases/currency-research-analasis-news-platform">Currency analysis and news platform</router-link></li>
                <li><router-link to="/cases/cannabis-platform">Cannabis Platform</router-link></li>
                <li><router-link to="/cases/doctormed">DoctorMed</router-link></li>
                <li><router-link to="/cases/social-network-for-dog-owners">Social Network for Dog Owners</router-link></li>
                <li><router-link to="/cases/real-estate-platform">Real Estate Platform</router-link></li>
                <li><router-link to="/cases/art-galleries-development">ArtGallery</router-link></li>
              </ul>
            </li>
            <li class="footer-menu-item no-change-color company">
              <p  class="footer-menu-item__title">Company</p>
              <ul class="footer-submenu">
                <li class="footer-menu-item menu-about-us">
                  <router-link to="/about">About Us</router-link>
                </li>
                <li class="footer-menu-item menu-career">
                  <router-link to="/career">Career</router-link>
                </li>
                <li class="footer-menu-item">
                  <router-link to="/#testimonials">Testimonials</router-link>
                </li>
                <li class="footer-menu-item menu-blog">
                  <router-link to="/blog">Blog</router-link>
                </li>
                <li class="footer-menu-item menu-">
                  <a href="https://talentbankai.com" target="_blank">Tech recruiters</a>
                </li>
                <li class="footer-menu-item menu-">
                  <a href="/sitemap.html" target="_blank">Sitemap</a>
                </li>
              </ul>
            </li>
            <li class="footer-menu-item no-change-color">
              <p class="footer-menu-item__title">Tech Stack</p>
              <ul class="footer-submenu">
                <li class="footer-menu-item menu-react">
                  <router-link to="/services/web-development/react" style="text-transform: none;">React.js</router-link>
                </li>
                <li class="footer-menu-item menu-react">
                  <router-link to="/services/web-development/node" style="text-transform: none;">Node.js</router-link>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
        <div v-lazyload data-src="/img/images-db/images/bg_img/img v8-4_0000.webp" class="lazy-bg footer-bg"></div>
      </div>
      <div class="bottom-footer">
        <ul class="social-links-footer social-link-list">
          <li>
            <a class="x-link" href="https://x.com/devbrotherlabs" target="_blank" rel="nofollow">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22px" viewBox="0 0 29 27" version="1.1">
                <g id="surface1">
                  <path d="M 22.8125 0 L 27.261719 0 L 17.496094 11.457031 L 28.902344 27 L 19.953125 27 L 12.945312 17.554688 L 4.921875 27 L 0.472656 27 L 10.816406 14.746094 L -0.105469 0 L 9.066406 0 L 15.398438 8.628906 Z M 21.257812 24.308594 L 23.722656 24.308594 L 7.773438 2.589844 L 5.125 2.589844 Z M 21.257812 24.308594 "/>
                </g>
              </svg>
            </a>
          </li>
          <li>
            <a target="_blank" href="https://www.linkedin.com/company/devbrother/about/" rel="nofollow" aria-label="devbrother company linkedin">
              <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <!-- Generator: Sketch 61 (89581) - https://sketch.com -->
                <title>LinkedIn</title>
                <desc>Created with Sketch.</desc>
                <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="footer" transform="translate(-443.000000, -360.000000)" fill="#FFFFFF" fill-rule="nonzero">
                    <g id="twitter">
                      <g transform="translate(443.000000, 360.000000)">
                        <path
                          d="M32,0 L32,32 L0,32 L0,0 L32,0 Z M11.3505859,12.4641113 L7.45385744,12.4641113 L7.45385744,24.1875 L11.3505859,24.1875 L11.3505859,12.4641113 Z M20.9152832,12.1889649 C18.8479004,12.1889649 17.9213868,13.3251953 17.4035644,14.1240234 L17.4035644,14.1240234 L17.4035644,12.4641113 L13.5070801,12.4641113 C13.5543258,13.4824942 13.5140794,22.6658991 13.5078578,24.0208157 L13.5070801,24.1875 L17.4035644,24.1875 L17.4035644,17.640625 C17.4035644,17.2902832 17.4287109,16.9401856 17.5317383,16.6896973 C17.8134766,15.9897461 18.4545899,15.2646484 19.5310059,15.2646484 C20.940918,15.2646484 21.5051269,16.3395996 21.5051269,17.9157715 L21.5051269,17.9157715 L21.5051269,24.1875 L25.4013672,24.1875 L25.4013672,17.465332 C25.4013672,13.8645019 23.4790039,12.1889649 20.9152832,12.1889649 Z M9.42822263,6.8125 C8.09521487,6.8125 7.22363281,7.68774413 7.22363281,8.83813475 C7.22363281,9.96313475 8.06933594,10.8632812 9.37695312,10.8632812 L9.37695312,10.8632812 L9.40234375,10.8632812 C10.7612305,10.8632812 11.6069336,9.96313475 11.6069336,8.83813475 C11.581543,7.68774413 10.7612305,6.8125 9.42822263,6.8125 Z"
                          id="LinkedIn"></path>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </a>
          </li>
          <li>
            <a class="insta-link" href="https://www.instagram.com/devbrother_company/?hl=ru" target="_blank"
              rel="nofollow" aria-label="devbrother company instagram">
              <svg fill="#1f2427" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="32px" height="32px">
                <path class="insta"
                  d="M 16 3 C 8.83 3 3 8.83 3 16 L 3 34 C 3 41.17 8.83 47 16 47 L 34 47 C 41.17 47 47 41.17 47 34 L 47 16 C 47 8.83 41.17 3 34 3 L 16 3 z M 37 11 C 38.1 11 39 11.9 39 13 C 39 14.1 38.1 15 37 15 C 35.9 15 35 14.1 35 13 C 35 11.9 35.9 11 37 11 z M 25 14 C 31.07 14 36 18.93 36 25 C 36 31.07 31.07 36 25 36 C 18.93 36 14 31.07 14 25 C 14 18.93 18.93 14 25 14 z M 25 16 C 20.04 16 16 20.04 16 25 C 16 29.96 20.04 34 25 34 C 29.96 34 34 29.96 34 25 C 34 20.04 29.96 16 25 16 z" />
              </svg>
            </a>
          </li>
          <li>
            <a href="mailto:contact@devbrother.com" aria-label="devbrother company email">
              <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"
                   xmlns:xlink="http://www.w3.org/1999/xlink">
                <!-- Generator: Sketch 58 (84663) - https://sketch.com -->
                <title>email</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="V2" transform="translate(-1411.000000, -41.000000)" fill="#FFFFFF" fill-rule="nonzero">
                    <path
                      d="M1411,41 L1411,73 L1443,73 L1443,41 L1411,41 Z M1416,52.3304 C1416,51.5136 1416.5328,51.2488 1417.184,51.7424 L1417.184,51.7424 L1425.9576,58.4024 C1426.2856,58.648 1426.7152,58.7688 1427.144,58.7632 C1427.572,58.7688 1428.0016,58.6488 1428.3296,58.4024 L1428.3296,58.4024 L1437.1016,51.7424 C1437.7528,51.2488 1438.2856,51.5136 1438.2856,52.3304 L1438.2856,52.3304 L1438.2856,63.2576 C1438.2856,64.0744 1437.6168,64.7432 1436.8,64.7432 L1436.8,64.7432 L1417.4856,64.7432 C1416.6688,64.7432 1416,64.0744 1416,63.2576 L1416,63.2576 Z M1436.2032,49.1432 C1437.0192,49.1432 1437.1648,49.5584 1436.5216,50.0648 L1436.5216,50.0648 L1428.4944,56.4232 C1428.1304,56.712 1427.6288,56.8392 1427.1424,56.8152 C1426.6552,56.8392 1426.1536,56.7112 1425.7896,56.4232 L1425.7896,56.4232 L1417.7624,50.0648 C1417.1208,49.5584 1417.2664,49.1432 1418.0832,49.1432 L1418.0832,49.1432 Z"
                      id="email"></path>
                  </g>
                </g>
              </svg>
            </a>
          </li>
          <li>
            <!--
            <a href="skype:yuraone3">
              <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>skype</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="V2" transform="translate(-1515.000000, -41.000000)" fill="#FFFFFF" fill-rule="nonzero">
                        <g id="skype" transform="translate(1515.000000, 41.000000)">
                            <path d="M20.102189,15.776633 C19.6551033,15.4821626 19.1153934,15.2344615 18.4818637,15.0289582 C17.8474198,14.8246505 17.1406066,14.6372923 16.3631121,14.4689231 C15.7428044,14.323411 15.2957187,14.2129231 15.0264967,14.1372484 C14.7609319,14.0624879 14.4963516,13.9591033 14.2357099,13.8258286 C13.9760527,13.6935385 13.7729407,13.5371956 13.6274286,13.3569407 C13.484378,13.1790769 13.413556,12.9701978 13.4123604,12.7224967 C13.413556,12.3271033 13.6215912,11.9905055 14.0566505,11.6996923 C14.4892484,11.4135209 15.0612396,11.2667429 15.7775473,11.2667429 C16.5517363,11.2654769 17.1070593,11.4014945 17.4446418,11.6624176 C17.7908044,11.929178 18.0877363,12.3017846 18.336633,12.7786901 C18.533556,13.1214769 18.7150769,13.3667165 18.8882989,13.5217934 C19.0661626,13.6815121 19.3221626,13.7559209 19.6489143,13.7559209 C20.0107604,13.7571165 20.3209143,13.6272879 20.5636923,13.3712879 C20.8064703,13.1164835 20.9301802,12.8245451 20.9301802,12.5035604 C20.9301802,12.1586637 20.8341802,11.8038505 20.6418989,11.442356 C20.4508132,11.0805099 20.1468484,10.7368088 19.7345055,10.4097758 C19.320967,10.0830242 18.8015824,9.8221011 18.1803604,9.62482637 C17.5566769,9.4279033 16.8184967,9.33035604 15.9677187,9.33035604 C14.9015912,9.33035604 13.9711297,9.47832967 13.1816088,9.77526154 C12.3896264,10.0709275 11.7812747,10.4974066 11.3607033,11.0539956 C10.9413275,11.6081231 10.7308308,12.2462945 10.7308308,12.9589451 C10.7308308,13.7066198 10.9293011,14.3376879 11.3280703,14.8447648 C11.7259253,15.3484659 12.2631736,15.7463209 12.9376352,16.0370637 C13.6118154,16.3281582 14.4434637,16.5804308 15.437644,16.7967648 C16.1779341,16.9530374 16.7693363,17.1008 17.2093187,17.241389 C17.6477538,17.3786022 18.0013011,17.5767912 18.2754462,17.8377143 C18.5455824,18.0937143 18.6779429,18.4229275 18.6779429,18.8377319 C18.6779429,19.3580308 18.4327033,19.7885187 17.9219692,20.1417143 C17.4148923,20.4928 16.7511912,20.6693978 15.9293187,20.6693978 C15.3293363,20.6693978 14.8499692,20.5829626 14.4893187,20.4084747 C14.125011,20.2343385 13.843833,20.0118857 13.644378,19.7451253 C13.4434462,19.4759033 13.2536264,19.1380396 13.0794198,18.7331516 C12.9351033,18.3845275 12.7572396,18.1202286 12.5455473,17.9387077 C12.3316747,17.7559209 12.0707516,17.6645626 11.7655209,17.6645626 C11.3929143,17.6645626 11.0781187,17.7811692 10.8328791,18.0143824 C10.591367,18.2464 10.4663912,18.5300396 10.4663912,18.8555956 C10.4663912,19.4097934 10.6670418,19.9771429 11.0648264,20.5565187 C11.4602198,21.1358945 11.9758769,21.599578 12.6103912,21.9457407 C13.504844,22.4303824 14.6368703,22.669433 16.0048527,22.669433 C17.1467253,22.669433 18.1347165,22.4940308 18.9710066,22.1404835 C19.8063824,21.7896791 20.4445538,21.3004659 20.8796132,20.6743209 C21.3146725,20.0490901 21.5334681,19.3435429 21.5322077,18.5576791 C21.5322077,17.9062857 21.4072967,17.3521582 21.1549538,16.8988835 C20.9040176,16.4458198 20.5516659,16.0711033 20.102189,15.776633 Z" id="Path"></path>
                            <path d="M0,0 L0,32 L32,32 L32,0 L0,0 Z M20.8651956,27.0769231 C19.6682549,27.0769231 18.5516308,26.7369495 17.6033758,26.1525802 C17.0806154,26.2356396 16.544633,26.2778374 15.9987341,26.2778374 C10.3233407,26.2778374 5.72244396,21.676589 5.72244396,16 C5.72244396,15.4532571 5.76675165,14.9205802 5.84734945,14.3966242 C5.26213626,13.4471033 4.92307692,12.3316747 4.92307692,11.1347341 C4.92307692,7.70306813 7.70433407,4.92307692 11.1348044,4.92307692 C12.3317451,4.92307692 13.4483692,5.26213626 14.3954286,5.84734945 C14.918189,5.76548571 15.4545231,5.72117802 16.0000703,5.72117802 C21.6766593,5.72117802 26.2776264,10.3220747 26.2776264,15.9999297 C26.2776264,16.5457582 26.2345143,17.0805451 26.1514549,17.6033055 C26.7379341,18.5516308 27.0769934,19.6682549 27.0769934,20.8654769 C27.0769934,24.2956659 24.2956659,27.0769231 20.8651956,27.0769231 Z" id="Shape"></path>
                        </g>
                    </g>
                </g>
            </svg>
            </a>
            -->
          </li>
        </ul>
        <ul class="privacy-list-footer">
          <li>
            <router-link to="/privacy-policy">Privacy Policy</router-link>
          </li>
          <li>
            <router-link to="/cookies-policy">Cookies Policy</router-link>
          </li>
          <li>
            <router-link to="/terms-and-conditions">Terms & Conditions</router-link>
          </li>
        </ul>
        <div class="copyring">© Copyright {{ fullYear() }} - DevBrother</div>
        <a href="//www.dmca.com/Protection/Status.aspx?ID=54e19d90-f679-40d4-a584-66b9c04230da" title="DMCA.com Protection Status" class="dmca-badge"> <img src ="https://images.dmca.com/Badges/dmca_protected_sml_120m.png?ID=54e19d90-f679-40d4-a584-66b9c04230da"  alt="DMCA.com Protection Status" /></a>
      </div>
    </div>
    <div class="popup" :class="{ 'hide-popup': !showModal }">
      <div class="popup-wrapper">
        <div class="popup-inner">
          <div class="popup-content subscribe-popup">
            <button class="close-popup" @click="closePopup()" type="button" aria-label="close popup"></button>
            <div class="">Your message was successfully sent.<br />We will respond to you as soon as possible.</div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import { FooterMenu } from "../constants/consts";
import { requestGet, requestPost } from "../../services/axios.js";
let vm = {}
export default {
  name: "app-footer",
  data() {
    return {
      FooterMenu,
      mail: "",
      showModal: false,
      showCopyModal1: false,
      showCopyModal2: false,
      showCopyModal3: false,
      showCopyModal4: false,

    }
  },
  beforeCreate() {
    vm = this;
  },
  mounted() {
    vm.body = document.querySelector("body");
  },
  methods: {
    copyToClipboard: (id, del) => {
      const str = document.getElementById(id).getAttribute('href').replace(del, '');
      const el = document.getElementById('tmpTextField');
      el.textContent=str;
      el.select();
      navigator.clipboard.writeText(str)
    },
    checkForEmptiness: (field, event) => {
    },
    sendMail: () => {
      const validEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (validEmail.test(vm.mail)) {
        requestPost("/subscribe", { email: vm.mail })
          .then(res => {
            if (res.status) {
              vm.showPopup();
              vm.mail = "";
            } else {
              console.log("Email send failed, error", res.error);
              console.log("resend email");
              //vm.sendMail();
            }
          })
          .catch(error => {
            return { status: false, error };
          });
      }
    },
    showPopup: () => {
      vm.showModal = true;
      vm.body.classList.add('ban-scroll');
    },
    closePopup: () => {
      vm.showModal = false;
      vm.body.classList.remove('ban-scroll');
    },
    fullYear() {
      const currentTime = new Date();
      return currentTime.getFullYear();
    },
    showCopyPopup1: () => {
      vm.showCopyModal1 = true;
      vm.showCopyModal2 = false;
      vm.showCopyModal3 = false;
      vm.showCopyModal4 = false;
      setTimeout(() => {
        vm.showCopyModal1 = false;
      }, 2000);
    },
    showCopyPopup2: () => {
      vm.showCopyModal2 = true;
      vm.showCopyModal1 = false;
      vm.showCopyModal3 = false;
      vm.showCopyModal4 = false;
      setTimeout(() => {
        vm.showCopyModal2 = false;
      }, 2000);
    },
    showCopyPopup3: () => {
      vm.showCopyModal3 = true;
      vm.showCopyModal1 = false;
      vm.showCopyModal2 = false;
      vm.showCopyModal4 = false;
      setTimeout(() => {
        vm.showCopyModal3 = false;
      }, 2000);
    },
    showCopyPopup4: () => {
      vm.showCopyModal4 = true;
      vm.showCopyModal1 = false;
      vm.showCopyModal2 = false;
      vm.showCopyModal3 = false;
      setTimeout(() => {
        vm.showCopyModal4 = false;
      }, 2000);
    },

  }
};
</script>
<style lang="scss" scoped scoped>
.industry {
  margin-top: 30px;
}

.footer-submenu {
  text-transform: capitalize;

  li {
    white-space: nowrap;
  }
}

.insta-link, .x-link {
  background: white;
}

.insta-link:hover, .x-link:hover  {
  background: white;
}

.insta-link svg:hover path, .x-link svg:hover path {
  fill: #06c6ff;
}

.x-link {
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

#tmpTextField {
  position: absolute;
  left: -200%;
  visibility: hidden;
}

.popup-copy-contact {
  position: absolute;
  z-index: 11;
  right: 0px;
  left: 25px;
  top: -4px;
  width: max-content;
  padding: 6px;
  font-size: 14px;
  border-radius: 3px;
  color: #1f2427;
  background-color: #ffffff;
}

.block-button {
  pointer-events: none;
}

.privacy-list-footer {
  display: flex;
  align-items: center;
  white-space: nowrap;
  color: #bcbcbc;

  li:not(:last-child) {
    margin-right: 15px;
  }
}

@media (max-width: 990px) {
  .bottom-footer {
    flex-direction: column;
  }

  .social-links-footer {
    margin-bottom: 20px;
  }

  .privacy-list-footer {
    margin-bottom: 20px;
  }
}

@media (max-width: 768px) {
  .industry {
    margin-top: 20px;
  }

  .dmca-badge {
    margin-top: 15px;
  }
}

@media (max-width: 576px) {
  .popup-copy-contact {
    left: -45px;
    top: -26px;
    padding: 4px;
  }
}

@media (max-width: 450px) {
  .privacy-list-footer {
    flex-direction: column;

    li:not(:last-child) {
      margin-right: 0px;
      margin-bottom: 15px;
    }
  }
}

@media (max-width: 360px) {
  .footer .footer-menu {
    justify-content: flex-end;
    padding-right: 50px;
    // justify-content: start;
    // padding-left: 30px;
  }

  // .footer .footer-menu .footer-menu-list {
  //   width: fit-content;
  // }
}
</style>
